import React, { useMemo } from 'react';
import { getPeriodStatus, PeriodicityPeriods } from '@allbin/mobilix-utils';
import { getPeriodStatusColorIcon } from '../../helpers/periodicity_helpers';
import { cn } from '../../helpers/classnames';
import EntityListItem from '../EntityListItem/EntityListItem';

interface EntityCheckInRowProps {
  entity: Entity;
  periods: PeriodicityPeriods;
  even?: boolean;
}

const EntityCheckInRow: React.FC<EntityCheckInRowProps> = ({
  entity,
  periods: { periods, activePeriodIndex },
  even,
}) => {
  const className = useMemo(
    () => cn('flex items-center justify-center', !even && 'bg-background-200'),
    [even],
  );

  const previousStatus = useMemo(
    () =>
      activePeriodIndex === 0
        ? null
        : getPeriodStatus(
            periods[activePeriodIndex - 1],
            entity.checkins.contractor,
          ),
    [periods, activePeriodIndex, entity.checkins.contractor],
  );

  const previousStatusColor = useMemo(() => {
    if (!previousStatus) return null;

    return getPeriodStatusColorIcon(previousStatus);
  }, [previousStatus]);

  const activeStatus = useMemo(
    () =>
      getPeriodStatus(periods[activePeriodIndex], entity.checkins.contractor),
    [periods, activePeriodIndex, entity.checkins.contractor],
  );

  const activeStatusColor = useMemo(() => {
    return getPeriodStatusColorIcon(activeStatus);
  }, [activeStatus]);

  if (!entity) {
    return null;
  }

  return (
    <>
      <div className={cn('col-span-6', className)}>
        <EntityListItem entity={entity} />
      </div>
      <div className={cn('col-span-3', className)}>{previousStatusColor}</div>
      <div className={cn('col-span-3', className)}>{activeStatusColor}</div>
    </>
  );
};

export default EntityCheckInRow;
